export function showModal(show: boolean) {
  if (import.meta.server) return;
  if (show) {
    document.body.classList.add('globalModalOpen');
  } else {
    document.body.classList.remove('globalModalOpen');
  }
}
